import { referenceDataService } from './referenceData';

import { SZ_DOCUMENT_MAIL_SERVICE, SZ_MAIL_SERVICE, SZ_REFERENCE_DATA } from '../../../actions/sizotsaFuneralClaim/referenceData';
import { claimMailService } from './claimMailService';
import { uploadDocumentMailService } from './uploadDocumentMailService';

export const sizotsaFuneralClaimServices = (store, next, action) => {
    // if (action.type===DLP_CONFIRM_DETAILS_SUBMIT_APPLICATION_SEND){
    //     return submitDlpApplicationService(store, next, action);
    //   }
    if (action.type.startsWith(SZ_REFERENCE_DATA)) return referenceDataService(store, next, action);
    if (action.type.startsWith(SZ_MAIL_SERVICE)) return claimMailService(store, next, action);
    if (action.type.startsWith(SZ_DOCUMENT_MAIL_SERVICE)) return uploadDocumentMailService(store, next, action);

    return null;
};
